import { useQuery, keepPreviousData as previousPlaceholder } from '@tanstack/react-query';

import { ApiLocationTypesResponse } from '../lib/api/Locations';

import { useApi } from '../contexts/ApiContext';

type UseLocationTypesOptions = Omit<
    Parameters<
        typeof useQuery<
            ApiLocationTypesResponse,
            Error,
            ApiLocationTypesResponse,
            ['location_types', Record<string, unknown> | null]
        >
    >[0],
    'queryKey' | 'queryFn'
> & {
    keepPreviousData?: boolean;
};

export default function useLocationTypes(query = null, opts: UseLocationTypesOptions = null) {
    const api = useApi();
    const { keepPreviousData = true } = opts || {};
    const { data = null, ...queryResult } = useQuery({
        queryKey: ['location_types', query],
        queryFn: ({ queryKey: [, queryParam], signal }) =>
            api.locations.locationTypes({ paginated: false, ...queryParam }, null, null, {
                signal,
            }),
        placeholderData: keepPreviousData ? previousPlaceholder : null,
        ...opts,
    });

    // const { data: items = null, pagination = null } = data || {};

    return {
        items: data,
        //   pagination,
        ...queryResult,
    };
}
